export default __webpack_public_path__ + "static/media/pexels-yuri-manei-2272854.9ba4fa46.jpg";